const API_BASE_URL = 'https://api-5iacy4tfya-uc.a.run.app'; 

export default API_BASE_URL;